<template>
	<div class="toggle flex-right">
		<i class="fas fa-info-circle fa-lg" style="color: #399ec9" />
		<div class="data-toggle" :class="{'bottom': direction == 'bottom', 'top': direction == 'top'}"
			v-html="src"
		/>
	</div>
</template>

<script>
export default {
	props: {
		direction: {
			type: String,
			default: 'bottom'
		},
		src: {
			type: String,
			default: null
		}
	}
}
</script>

<style scoped>

.toggle {
	display: inline-block;
	cursor: pointer;
	position: relative;
}

.toggle:hover .data-toggle{
	opacity: 1;
	display: block;
}
.data-toggle.bottom::after  {
	content: '';
	position: absolute;
	top: -13px;
	right: 30px;
	transform: translateX(0%) translateY(3px);
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
}


.data-toggle.top {
	bottom: 30px;
}

.data-toggle.top::after  {
	content: '';
	position: absolute;
	bottom: -9px;
	right: 30px;
	transform: translateX(0%) translateY(3px);
	border-left: 10px solid transparent;
	border-right: 10px solid transparent;
	transform: rotate(180deg);
}

.data-toggle::after {
	border-bottom: 10px solid rgba(69, 178, 255, 0.9);
}

.data-toggle {
	border-radius: 4px;
	display: none;
	margin: 10px 0;
	transition: opacity 2s ease;
	padding: 10px;
	background-color: rgba(69, 178, 255, 0.9);
	position: absolute;
	z-index: 1070;
	color: white;
	width: 200px;
	transform: translateY(0px) translateX(-75%);
	font-style: normal;
	font-weight: 300;
	line-height: 1.5;
	text-align: left;
	text-decoration: none;
	text-shadow: none;
	text-transform: none;
	letter-spacing: normal;
	word-break: normal;
	word-spacing: normal;
	white-space: normal;
	line-break: auto;
	font-size: 12px;
	word-wrap: break-word;
	opacity: 0;
}

@media (max-width: 1024px) {
	.data-toggle {
		transform: translateY(0px) translateX(-85%);
	}

	.data-toggle::after  {
		top: -13px;
		left: 85%;
		transform: translateX(0%) translateY(3px);
		border-left: 10px solid transparent;
		border-right: 10px solid transparent;
	}
}
</style>
